// define root api
import { HTTP_API, HCCD_MS, HCCD_N8N } from "../config";
export const HOST_API = HTTP_API;
export const HCCCD_API = HCCD_MS;
export const HCCCD_API_N8N = HCCD_N8N;

export const SSO_AUTH_TOKEN = HCCD_MS + "/auth/token";
export const SSO_AUTH_SIGNOUT = HCCD_MS + "/auth/signout";
export const SSO_AUTH_API_CITIZEN = HCCD_MS + "/login/citizen";
export const SSO_AUTH_API_CITIZEN_CAPTCHA = HCCD_MS + "/login/captcha";
export const SSO_AUTH_API_CITIZEN_LOGOUT = HCCD_MS + "/login/logout";
export const SSO_AUTH_API_VNEID = HCCD_MS + "/vneid/login";

export const REGISTER_GET_TOKEN = "/register/get_token";
export const REGISTER_VERIFY_TOKEN = "/register/verify_token";
export const REGISTER_CHECK_ACCOUNT = "/api/users/register/check-account";
export const REGISTER_CREATE = "/api/users/register/create";

//AUTH vs REGISTER vs USERS
export const AUTH_SIGNIN = "/api/auth/signin";
export const AUTH_OUT = "/api/auth/signout";
export const AUTH_REFRESH_TOKEN = "/api/auth/refresh-token";
export const AUTH_CHECK_SUPER = "/api/auth/check-super";
export const USER_UPDATE = "/api/users/update";
export const SUPER_CHANGE_PASSWORD = "/api/users/change-password";
export const LOGIN_RECEIVE_CITIZEN_PASSWORD =
  HCCD_MS + "/login/receive-citizen-password";

export const CHANGE_PROFILE = "/api/me/change-profile";
export const CHANGE_PASSWORD = "/api/me/change-password";
export const GET_INFO_BY_EMAIL = "/api/me/info-by-email";
export const GET_MY_BUSINESSES = "/api/me/businesses";

export const PHONE_VERIFY_SEND_OTP = "/login/verify-phone/send-otp";
export const PHONE_VERIFY_CONFIRM_OTP = "/login/verify-phone/confirm-otp";

// Kho Giáº¥y Tá» â€“ endpoint an toÃ n cÃ³ kiá»ƒm soÃ¡t quyá»n chá»§ sá»Ÿ há»¯u
export const ME_GIAY_TO = "/api/me/giay-to";
export const ME_GIAY_TO_FILE = "/api/me/giay-to/file";
export const ME_GIAY_TO_LOG_DOWNLOAD = "/api/me/giay-to/log-download";

//DATA
export const DATA = "/api/data";
export const GENERAL = "/api/general";
export const MEDIA_UPLOAD = "/api/media/upload";
export const MEDIA_DOWNLOAD = "/api/media/download";
export const MEDIA_FILE = "/api/media/file";
export const MEDIA_VIDEO = "/api/media/video";
export const MEDIA_CONVERT_PDF = "/api/media/convert/pdf";
export const MEDIA_CONVERT_IMAGE = "/api/media/convert/image";
export const FILE_BASE64 = "/api/files";
// MS
export const MS_LGSP_DANHMUC_DANTOC = "/ms/lgsp/api/danh-muc/dan-toc";
export const MS_LGSP_DANHMUC_QUOCGIA = "/ms/lgsp/api/danh-muc/quoc-gia";
export const MS_LGSP_DANHMUC_GIOITINH = "/ms/lgsp/api/danh-muc/gioi-tinh";
export const MS_LGSP_DANHMUC_TINHTRANGHONNHAN =
  "/ms/lgsp/api/danh-muc/tinh-trang-hon-nhan";
export const MS_LGSP_DANHMUC_NHOMMAU = "/ms/lgsp/api/danh-muc/nhom-mau";
export const MS_LGSP_DANHMUC_DONVIHANHCHINHCAPTINH =
  "/ms/lgsp/api/danh-muc/don-vi-hanh-chinh-cap-tinh";
export const MS_LGSP_DANHMUC_DONVIHANHCHINHCAPHUYEN =
  "/ms/lgsp/api/danh-muc/don-vi-hanh-chinh-cap-huyen";
export const MS_LGSP_DANHMUC_DONVIHANHCHINHCAPXA =
  "/ms/lgsp/api/danh-muc/don-vi-hanh-chinh-cap-xa";
export const MS_LGSP_DANHMUC_QUANHETRONGGIADINH =
  "/ms/lgsp/api/danh-muc/quan-he-trong-gia-dinh";
export const MS_LGSP_DANHMUC_DONVIHANHCHINH_BTP =
  "/ms/lgsp/api/danh-muc/don-vi-hanh-chinh-btp";
export const MS_LGSP_DANHMUC_DONVIKHAISINHCAPTINH =
  "/ms/lgsp/api/danh-muc/khai-sinh/don-vi-khai-sinh-cap-tinh";
export const MS_LGSP_DANHMUC_DONVIKHAISINHCAPXA =
  "/ms/lgsp/api/danh-muc/khai-sinh/don-vi-khai-sinh-cap-xa";
export const MS_LGSP_DANHMUC_DONVI = "/ms/lgsp/api/danh-muc/don-vi";
export const MS_LGSP_DANHMUC_BENHVIEN = "/ms/lgsp/api/danh-muc/benh-vien";

export const MS_LGSP_CONGDAN_CCCD = "/ms/lgsp/api/cong-dan/cccd";
export const MS_LGSP_CONGDAN_BHXH = "/ms/lgsp/api/cong-dan/bhxh";
//
export const HCCD_TTHC_HO_SO_KHAI_SINH = "/api/tthc/hoso-khaisinh";
export const MS_LGSP_DANHMUC_LOAI_HS = "/ms/lgsp/api/danh-muc/loai-ho-so";

// UC Tự động hóa — Kiểm thử
export const UC_CLT_HOSO_KHAI_SINH = "/ms/restheart/DB_HCCCD/cltHosoKhaisinh";
export const UC_THUONG_TRU_GENERATE_CT01 = "/api/tthc/ho-so-thuong-tru/generate-ct01-khaisinh";
export const UC_VONG_DOI_TRIGGER_DO_QUET = "/api/vongdoi/trigger-do-quet";
export const UC_VONG_DOI_TRIGGER_GIA_HAN = "/api/vongdoi/trigger-giahan";

// UC Tự động cập nhật trạng thái xử lý chủ động — Kiểm thử
export const UC_IGATE_TRIGGER_PERIODIC_SYNC = "/api/public/igate/trigger-periodic-sync";
export const UC_IGATE_SYNC_BTP = "/api/public/igate/sync-btp";
export const UC_IGATE_UPDATE_STATUS = "/api/public/igate/update-status";
export const UC_IGATE_NOTIFY_STATUS = "/api/public/igate/notify-status-change";
export const UC_IGATE_DANH_SACH_KIEM_THU = "/api/public/igate/danh-sach-kiem-thu";

// UC Thông báo Mobile — APNS & FCM Giả lập
export const PUBLIC_NOTIFY_APNS_SEND = "/api/public/notify/apns/send-public";
export const PUBLIC_NOTIFY_FCM_SEND = "/api/public/notify/fcm/send-public";
export const PUBLIC_NOTIFY_MOBILE_STREAM = "/api/public/notify/mobile/stream";
export const PUBLIC_NOTIFY_MOBILE_LATEST = "/api/public/notify/mobile/latest";
export const PUBLIC_NOTIFY_MOBILE_CLEAR = "/api/public/notify/mobile/clear";

//
export const HCCCD_PDF_GCS_CREATE = "/api/pdf-template/giaychungsinh/create";
export const HCCCD_PDF_DKKS_CREATE =
  "/api/pdf-template/tokhaidangkygiaykhaisinh/create";

export const HCCCD_PDF_DKKS_CREATE_TEMPLATE =
  "/api/pdf-template/tokhaidangkygiaykhaisinh/create-template";

// TABLE
export const DB_THONG_BAO = HCCD_MS + "/ms/restheart/DB_HCCCD_THONG_BAO";
export const DB_HCCCD_DANH_MUC = HCCD_MS + "/ms/restheart/DB_HCCCD_DANH_MUC";
export const HCCD_CONG_DAN_CLT_DONVI = "/ms/restheart/DB_HCCCD_CAN_BO/cltDonVi";
export const CLT_BAI_VIET = "/cltBaiViet";
export const CLT_CONFIG = "/cltConfig";
export const CLT_DANH_MUC_UNG_DUNG = "/cltDanhMucUngDung";
export const CLT_DON_VI = "/cltDonVi";
export const CLT_LOG_API = "/cltLogApi";
export const CLT_MENU = "/cltMenu";
export const CLT_NHOM_QUYEN = "/cltNhomQuyen";
export const CLT_NHOM_QUYEN_NGUOI_DUNG = "/cltNhomQuyenNguoiDung";
export const CLT_USERS = "/cltUsers";
export const CLT_THONG_BAO = "/cltLogThongBao";
export const CLT_RATING_THONG_BAO = "/cltRatingThongBao";
export const CLT_LOG_THONG_BAO = "/cltLogThongBao";
export const CLT_DANH_MUC_TTHC = "/cltDanhMucTTHC";
export const CLT_DANH_MUC_CO_QUAN_XU_LY_TTHC =
  "/cltConfigIGATE_Coquan_DanhmucTTHC";
export const CLT_DANH_MUC_CO_QUAN_IGATE = "/cltDanhMucIGATE_DanhMucCoQuan";
export const CLT_DANH_MUC_CO_QUAN_IGATE_CAP_CCCD =
  "/cltDanhMucIGATE_DanhMucCoQuanCapCCCD";
export const CLT_DANH_MUC_QUOC_GIA_IGATE = "/cltDanhMucIGATE_DanhMucQuocGia";
export const CLT_DANH_MUC_TINH_IGATE = "/cltDanhMucIGATE_DanhMucTinhThanh";
export const CLT_DANH_MUC_XA_PHUONG_IGATE = "/cltDanhMucIGATE_DanhMucXa";
export const CLT_CAP_CN_ATTP_CONG_THUONG = "/cltCapGcnVSATTP_SCT";
export const CLT_CAP_CN_ATTP_KINH_DOANH_YT = "/cltCapGcnVSATTP_BYt";
export const CLT_DANH_MUC_FILE_MAU_IGATE = "/cltDanhMucFileMauIgate";
export const CLT_HOSO_LIEN_THONG_KHAU_TU_THUONG_TRU_TAM_TRU =
  "/cltHoSoLienThongKhaiTuThuongTruTamTru";
export const CLT_DANH_MUC_DONVI_HANHCHINH_CAP3 =
  "/cltDanhMucDonViHanhChinhCap3";
export const CLT_DANH_MUC_DONVI_HANHCHINH_CAP1 =
  "/cltDanhMucDonViHanhChinhCap1";
export const DB_HCCCD_CONG_DAN = HCCD_MS + "/ms/restheart/DB_HCCCD_CONG_DAN";
export const CLT_LOG_THONG_BAO_CAP_NHAT = "/cltThongBaoLogCapNhat";
export const CLT_THONG_BAO_LUU_TRU = "/cltThongBaoLuuTru";
export const CLT_CONFIG_THONG_BAO = "/cltConfigThongBao";
export const CLT_LICH_HEN = "/cltLichHen";
export const CLT_PHAN_ANH = "/cltPhanAnh";

// DASHBOARD
export const AGGRS = "/api/aggrs";
export const AGGRS_DON_VI = "/don-vi";

// GUEST
export const GUEST = "/api/guest";
export const GUEST_DON_VI = "/don-vi";
export const GUEST_MENU = "/menu";


// GSP
export const GSP = "/api/gsp";

// GMAP
export const GMAP = "/api/gmap";

// WEATHER
export const WEATHER_CURRENT = "/api/weather/current";
export const WEATHER_NEWS_CRAWL = "/api/weather-news/crawl";
export const WEATHER_NEWS_SAVE = "/api/weather-news/save";
export const WEATHER_NEWS_SOURCES = "/api/weather-news/sources";
export const WEATHER_NEWS_LIST = "/api/weather-news";
export const WEATHER_NEWS_DELETE = "/api/weather-news";

// VÒNG ĐỜI
export const HCCD_VONG_DOI_GIAI_DOAN =
  "/ms/restheart/DB_HCCCD_VONG_DOI/cltGiaiDoanVongDoi";
export const HCCD_VONG_DOI_DN_GIAI_DOAN =
  "/ms/restheart/DB_HCCCD_VONG_DOI/cltGiaiDoanVongDoiDoanhNghiep";
